import React, { useContext } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import ButtonProgreso from '../buttons/Button'

import { Text, TextColored } from '../../components/typography';

import { Progreso } from '../../assets/icons/card';
import BackIcon from '../../assets/icons/chevron-back.svg';
import { ProgresoMobile, Instructivo } from '../../assets/icons/card';
import mobile from '../../assets/images/mobile.png';
import Progress from "../progress/Progress";

import { ThemeContext } from '../../theming';

import useWindowDimensions from '../../helpers/useWindowDimensions';
import NumberFormat from 'react-number-format';
import { useEffect } from 'react';

function CardResumenPago({ children, title, text, btnBack, table = {}, subtitle = null, footer = null, instructivos = [], icon = null, size = "md",
    progress = null, irPagar = null, volverInicio = null }) {
    const app = useContext(ThemeContext);
    const navigate = useNavigate();
    const { body14, body32, body12, body28 } = app.theme.font;
    const { width } = useWindowDimensions();

    const icono = {
        top: '-20px',
        right: '21px',
        position: 'relative',
    };
    const iconoMobile = {
        top: '-50px',
        right: '21px',
        position: 'relative'
    };
    useEffect(() => window.scrollTo(0, 0), [])
    return (
        <>
            {width >= 701 && <Progreso style={width >= 701 ? icono : {}} />}
            <Row className={width >= 701 ? 'mt-5 mx-5 d-flex justify-content-center justify-content-xl-start align-items-center' :
                'd-flex justify-content-center justify-content-xl-start'}>
                {width >= 701 ?
                    <>
                        {icon && <Col className='d-flex justify-content-end align-items-center' xs={size === "xl" ? 1 : 2}>{icon}</Col>}
                        <Col className='d-flex justify-content-start align-items-center' xs={3} xl={3}>
                            <Text type='primary' size={body28}>
                                {title}:
                            </Text>
                        </Col>
                        <Col className='d-flex justify-content-start' xs={5} xl={5}>
                            <TextColored className='text-justify' size={body12} type='gray'>
                                {text}
                            </TextColored>
                        </Col>
                        {btnBack && <Col xs={2} xl={2}>
                            {/* <Link to="/" state={{ state }}> */}
                            {/* <ButtonProgreso
                                    className='noprint'
                                    sizeText={1}
                                    onClick={()=>navigate(-1)}>
                                </ButtonProgreso> */}
                            <img style={{
                                cursor: "pointer"
                            }}
                                src={BackIcon} alt="Regresar home"
                                onClick={() => navigate(-1)}
                            />
                            {/*    </Link> */}
                        </Col>}
                        {progress && <div className={`mx-auto ${width >= 1200 ? "w-50":"w-100"}`}>
                            <Progress progress={progress} />
                        </div>}
                    </>
                    :
                    // Mobile vista
                    <Col style={{ marginLeft: '60px' }}>
                        <Row style={{
                            marginTop: '-15px',
                            marginLeft: '-76px'
                        }}>
                            {<ProgresoMobile style={iconoMobile} />}
                        </Row>
                        <Row style={{ marginTop: '60px' }} className='d-flex justify-content-start align-items-center' xs={12}>
                            <Col xs={btnBack ? 9 : 12}>
                                <Text type='primary' size={body28} >
                                    {title}:
                                </Text>
                            </Col>
                            {btnBack && <Col xs={2}>
                                <img style={{
                                    cursor: "pointer"
                                }}
                                    src={BackIcon} alt="Regresar home"
                                    onClick={() => navigate(-1)}
                                />
                            </Col>}


                        </Row>
                        <Row className='pr-4'>
                            <TextColored className='text-justify' size={body12} type='gray'>
                                {text}
                            </TextColored>
                        </Row>
                        {progress && <div className="mx-auto w-95">
                            <Progress progress={progress} />
                        </div>}
                    </Col>
                }
            </Row>
            <div className={width >= 701 ? 'm-5' : ''} >
                <Row className='mt-4 justify-content-center'>
                    {children}
                </Row>
                <Row className={`d-flex ${irPagar ? "justify-content-end" : "justify-content-center"} mt-2`}>
                    <div style={{ width: irPagar ? '150px' : '200px' }}>
                        {irPagar || volverInicio}
                    </div>
                </Row>
            </div>
        </>
    );
}

export default CardResumenPago;
